'use client'

import type { CmsItem } from '@/utils/api'

import { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'

import api from '@/utils/api'

import '@/styles/page.css'
import './UnitTrustPrice.css'

import type { UnitTrustPriceItem } from '@/app/unit-trust-price/page'

import { isEmpty } from 'lodash'

import { convertDateFormat } from '@/utils'

const UnitTrustPrice = ({ initialData }: { initialData: UnitTrustPriceItem | null }) => {
  const [unitTrustPrice, setUnitTrustPrice] = useState<CmsItem<'/unit-trust-prices'> | null>(
    initialData ?? null
  )

  const fetchUnitTrustPrice = async () => {
    try {
      const response = await api.get('/unit-trust-prices', { params: { populate: '*' } })
      setUnitTrustPrice(response.data.data[0])
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }

  // DELIBERATE CLIENT REFETCH (decided 2026-08-17) — do not remove.
  // initialData (build-time snapshot) paints instantly and is what crawlers index,
  // but a Strapi publish takes 3-15 min to reach prod via deploy-prod-on-publish.
  // Displaying a superseded unit trust price for that long is unacceptable, so this page
  // revalidates on mount. Excluded from tests/no-client-cms-fetch.spec.ts.
  // See docs/superpowers/plans/2026-08-17-remove-client-side-cms-refetch.md Task 5.
  useEffect(() => {
    fetchUnitTrustPrice()
  }, [])

  return (
    <div className="container page">
      <h1 className="page-title">Unit Trust Price</h1>

      <Table responsive="xs" bordered>
        <thead>
          <tr className="table-title">
            <th>Unit Trust Price</th>
            <th colSpan={2}>
              As of {!isEmpty(unitTrustPrice) && convertDateFormat(unitTrustPrice?.date)}
            </th>
          </tr>
          <tr className="table-head">
            <th>Fund</th>
            <th>NAV</th>
          </tr>
        </thead>
        <tbody>
          {!isEmpty(unitTrustPrice) &&
            unitTrustPrice?.unitTrusts?.map(item => {
              const formattedNav =
                !isNaN(Number(item.nav)) && !isNaN(Number.parseFloat(item.nav ?? ''))
                  ? Number.parseFloat(item.nav ?? '').toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 5
                    })
                  : item.nav
              return (
                <tr className="table-data" key={item.fund}>
                  <td>{item.fund}</td>
                  <td>{formattedNav}</td>
                </tr>
              )
            })}
        </tbody>
      </Table>
    </div>
  )
}

export default UnitTrustPrice
